import styles from "./sectionTitle.module.css";
import ImgBuilder from "../../assets/ImgBuilder";

const SectionTitle = ({ msg, abortFunction, settingsFunction}) => {

  return (
    <div className={styles.conSectionTitle}>
      <div className={styles.sectionTitle}>
        
        {msg.label}

        <div className={styles.abortGameCon}>
          <button onClick={settingsFunction} className={styles.abortGame}>
            <img alt="section" src={ImgBuilder.settingsIcon} className={styles.image}/>
          </button>
          <button onClick={() => abortFunction(false)} className={`${styles.abortGame} ${styles.cross}`}></button>
        </div>

      </div>
    </div>
  );
};
export default SectionTitle;
